export default {
  Level: {
    Employee: {
      label: '员工',
      value: "0",
    },
    FirstApproval: {
      label: '一级审批',
      value: "1",
    },
    SecondApproval: {
      label: '二级审批',
      value: "2",
    },
  },
};
